import { httpsCallable } from 'firebase/functions';
import { signInWithCustomToken } from 'firebase/auth';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { auth, db, functions } from '../firebase/client';

export async function sendLoginOtp(phoneE164: string): Promise<string> {
  const callable = httpsCallable(functions(), 'sendLoginOtp');
  const res = await callable({ phoneNumber: phoneE164 });
  const data = res.data as { verificationId?: string };
  const id = data.verificationId?.trim();
  if (!id) throw new Error('OTP send succeeded but verificationId is missing.');
  return id;
}

export async function verifyLoginOtp(
  verificationId: string,
  smsCode: string,
): Promise<void> {
  const callable = httpsCallable(functions(), 'verifyLoginOtp');
  const res = await callable({ verificationId, smsCode });
  const data = res.data as { customToken?: string };
  const token = data.customToken?.trim();
  if (!token) throw new Error('OTP verified but customToken is missing.');
  await signInWithCustomToken(auth(), token);
}

export async function syncPublicProfile(): Promise<void> {
  const user = auth().currentUser;
  if (!user) return;
  const phone = user.phoneNumber?.trim();
  const photo = user.photoURL?.trim();
  await setDoc(
    doc(db(), 'publicProfiles', user.uid),
    {
      ...(phone ? { phoneNumber: phone } : {}),
      ...(photo ? { photoUrl: photo } : {}),
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export async function removeLegacyPersonalWorkspaceCallable(): Promise<void> {
  try {
    const callable = httpsCallable(functions(), 'removeLegacyPersonalWorkspace');
    await callable({});
  } catch {
    /* optional cleanup */
  }
}

export async function deleteMyAccountCallable(): Promise<void> {
  const callable = httpsCallable(functions(), 'deleteMyAccount');
  await callable({});
}

export async function joinCompanyCallable(
  inviteCodeOrCompanyId: string,
  options?: { phoneNumber?: string; displayName?: string },
): Promise<{ companyId: string; companyName: string }> {
  const callable = httpsCallable(functions(), 'joinCompany');
  const displayName = options?.displayName?.trim();
  const phoneNumber = options?.phoneNumber?.trim();
  const res = await callable({
    inviteCodeOrCompanyId: inviteCodeOrCompanyId.trim(),
    ...(phoneNumber ? { phoneNumber } : {}),
    ...(displayName ? { displayName } : {}),
  });
  const data = res.data as {
    companyId?: string;
    companyName?: string;
  };
  if (!data.companyId || !data.companyName) {
    throw new Error('Invalid response from server');
  }
  return { companyId: data.companyId, companyName: data.companyName };
}
